module.exports = __webpack_public_path__ + "img/balloon2.21779d6c.png";